import {
  CLINIC_LOGO_MAX_HEIGHT,
  CLINIC_LOGO_MAX_WIDTH
} from "components/print-header/print-header-report/clinic-logo-constants";
import {
  CANADA_COUNTRY_VALUE,
  CANADA_PROVINCES,
  US_STATES,
  US_VIRGIN_ISLANDS_COUNTRY_VALUE,
  US_VIRGIN_ISLANDS_TERRITORIES
} from "constants/addresses";
import { formatPhoneNumber } from "utils/common";

import { CLINIC_OPTIONS } from "../merge-tags-options/clinic.utils";
import { MergeTagsReplaceHandler } from "./merge-tags-values";

export const CLINIC_VALUES: MergeTagsReplaceHandler = {
  [CLINIC_OPTIONS.PRACTICE_NAME]: ({ data }) => {
    return data.currentClinic?.practice.name;
  },
  [CLINIC_OPTIONS.PRACTICE_LOGO]: ({ data }) => {
    const clinicLogo =
      data.currentClinic?.logo || data.currentClinic?.practice?.logo;
    const clinicName = data.currentClinic?.practice?.name;
    if (!clinicLogo) return null;

    return `<img src="${clinicLogo}" title="${clinicName} Logo" alt="${clinicName} Logo" style="max-height: ${CLINIC_LOGO_MAX_HEIGHT}; max-width:${CLINIC_LOGO_MAX_WIDTH}">`;
  },
  [CLINIC_OPTIONS.CLINIC_NAME]: ({ data }) => {
    return data.currentClinic?.name;
  },
  [CLINIC_OPTIONS.CLINIC_FULL_ADDRESS]: ({ data }) => {
    const clinic = data.currentClinic;

    return [
      clinic?.street_address_1,
      clinic?.street_address_2,
      clinic?.city,
      `${clinic?.state || ""} ${clinic?.zip_code || ""}`.trim()
    ]
      .filter(Boolean)
      .join(", ");
  },
  [CLINIC_OPTIONS.CLINIC_STREET_ADDRESS_LINE1]: ({ data }) => {
    return data.currentClinic?.street_address_1;
  },
  [CLINIC_OPTIONS.CLINIC_STREET_ADDRESS_LINE2]: ({ data }) => {
    return data.currentClinic?.street_address_2;
  },
  [CLINIC_OPTIONS.CLINIC_CITY]: ({ data }) => {
    return data.currentClinic?.city;
  },
  [CLINIC_OPTIONS.CLINIC_STATE]: ({ data }) => {
    const stateOptions =
      data.currentClinic?.country === CANADA_COUNTRY_VALUE
        ? CANADA_PROVINCES
        : data.currentClinic?.country === US_VIRGIN_ISLANDS_COUNTRY_VALUE
          ? US_VIRGIN_ISLANDS_TERRITORIES
          : US_STATES;
    return stateOptions.getFromCode(data.currentClinic?.state);
  },
  [CLINIC_OPTIONS.CLINIC_ZIP_CODE]: ({ data }) => {
    return data.currentClinic?.zip_code;
  },
  [CLINIC_OPTIONS.CLINIC_PHONE_NUMBER]: ({ data }) => {
    return formatPhoneNumber(data.currentClinic?.phone ?? "");
  },
  [CLINIC_OPTIONS.CLINIC_FAX_NUMBER]: ({ data }) => {
    return formatPhoneNumber(data.currentClinic?.fax_phone ?? "");
  },
  [CLINIC_OPTIONS.CLINIC_GOOGLE_MAP_URL]: ({ data, allowHtml }) => {
    if (!data.currentClinic?.google_place_id) return null;

    if (!allowHtml) {
      return `https://www.google.com/maps/place/?q=place_id:${data.currentClinic?.google_place_id}`;
    }

    return `<a title="${data.currentClinic.name} on Google Maps" href="https://www.google.com/maps/place/?q=place_id:${data.currentClinic?.google_place_id}" target="_blank">${data.currentClinic.name} on Google Maps</a>`;
  },
  [CLINIC_OPTIONS.CLINIC_BUSINESS_NAME]: ({ data }) => {
    return data.currentClinic?.display_name;
  }
};
